// extracted by mini-css-extract-plugin
export default {"button-wrapper":"EJ9x24ar","label":"tNkj4BU0"};